"use client";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import makeStyles from "../../theming/make-styles.js";
import makePadding from "../utils/make-padding.js";
import { ButtonGroupContext } from "./button-group.js";
import Button from "./button.js";
const paddings = {
    small: 6,
    medium: 10,
    large: 14,
};
const useStyles = makeStyles()((theme, { round, size }) => {
    const padding = makePadding(paddings, theme);
    return {
        button: {
            padding: padding(size, theme.size(1)),
            borderRadius: round ? "100%" : undefined,
        },
    };
});
export const IconButton = React.forwardRef(function IconButton(_a, ref) {
    var { className, icon, round, size = "medium" } = _a, props = __rest(_a, ["className", "icon", "round", "size"]);
    const buttonGroupProps = useContext(ButtonGroupContext);
    const { classes, cx } = useStyles({ round, size: buttonGroupProps.size || size });
    return _jsx(Button, Object.assign({ ref: ref, className: cx(classes.button, className), "data-component": "icon-button", icon: icon, size: size }, props));
});
export default IconButton;
//# sourceMappingURL=icon-button.js.map